import { Button } from "primereact/button";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */

const SignInSignOut = () => {
  const navigate = useNavigate();

  // button animation
  useEffect(() => {
    const element = document.getElementById("bg-animation");
    if (element) {
      element.classList.add("bg-animate");
    }
  }, []);

  return (
    <>
      <div className="" id="bg-animation">
        <div className="full-screen-container">
          <div className="image-container text-white">
            <div className="image-home"></div>
          </div>
          <div className="flex">
            <div className="text-container">
              <h1 className="text-purple">Kindergarten Inclusion Support Program</h1>
              <p className="mx-5">
                The KIS Program Application Service is operated by Australian Healthcare Associates, on behalf of the Victorian Department of
                Education.
              </p>
              <p className="mx-5">
                Kindergartens can submit a KIS application by signing into the KIS portal and submitting an online application. Click on the{" "}
                <strong>KIS Portal</strong> button below to sign up or sign in to the portal.{" "}
              </p>
              <p className="mx-5">
                Further information about the KIS program, including application guidelines and forms, can be found on the{" "}
                <a
                  href="https://www.vic.gov.au/kindergarten-inclusion-children-disabilities"
                  target="_blank"
                  title="Link opens in a new tab"
                  rel="noreferrer">
                  Department's website
                </a>
                . <i className="pi pi-external-link"></i>
              </p>
              <p className="mx-5">
                Additional resources to assist kindergartens to sign in to the portal and complete an online application can be found by clicking on
                the <strong>KIS Resources</strong> button below.
                <p>
                  {" "}
                  <strong>
                    Prior to continuing, you must read our Privacy Notice, which is available&nbsp;
                    <a href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/10/KIS-Privacy-Notice.pdf" rel="noreferrer">
                      here
                    </a>
                  </strong>
                  .
                </p>
                <div>
                  <div className="flex flex-wrap">
                    <Button
                      className="filled-round-button landing mr-5 mt-2 mb-2"
                      label="KIS Resources"
                      onClick={() => navigate("/resources")}
                      icon="pi pi-book text-2xl"></Button>
                    <Button
                      className="filled-round-button-secondary landing mt-2 mb-2"
                      label="KIS Portal"
                      onClick={() => navigate("/login")}
                      icon="pi pi-desktop text-2xl"></Button>
                  </div>
                </div>
              </p>
              <div className="landing-page-msg-container">
                <p className="text-purple">
                  <strong>Upcoming KIS applications help desk closure</strong>
                </p>
                <p>
                  We advise that the KIS applications help desk will be closed from 12pm – 5pm on Thursday 11 December 2025, and will re-open at 9am
                  on Friday 12 December 2025.
                </p>
                <p>
                  The help desk will close for the holiday period from 5pm on Tuesday 23 December 2025, and will re-open at 9am on Monday 5 January
                  2026. You will be able to use the portal during these closure periods, however you will not have access to support from the help
                  desk if you have technical or other queries. We also advise that there may be a slight delay to advising application outcomes due to
                  the holiday period closure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const LandingPage = (props: { children: any }) => {
  return (
    <div>
      <SignInSignOut />
      {props.children}
    </div>
  );
};
